import * as React from 'react';
import { useEffect, useState } from 'react';
import { history } from '../history';
import { connect, useDispatch } from 'react-redux';
import { FaBuilding } from 'react-icons/fa';
import TreeView from '@mui/lab/TreeView';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import TreeItem from '@mui/lab/TreeItem';

const PartnerTree = ({ user, allgroups, partnertree, mypartner, selected, onChanged, allpartner, full = false }) => {

	const renderTree = (nodes) => (
		<TreeItem key={nodes._id} nodeId={nodes._id} label={<>
			<svg width="24" height="24" viewBox="0 0 384 512" xmlns="http://www.w3.org/2000/svg" class="icon-company">
				<path d="M336 0C362.5 0 384 21.49 384 48V464C384 490.5 362.5 512 336 512H240V432C240 405.5 218.5 384 192 384C165.5 384 144 405.5 144 432V512H48C21.49 512 0 490.5 0 464V48C0 21.49 21.49 0 48 0H336zM64 272C64 280.8 71.16 288 80 288H112C120.8 288 128 280.8 128 272V240C128 231.2 120.8 224 112 224H80C71.16 224 64 231.2 64 240V272zM176 224C167.2 224 160 231.2 160 240V272C160 280.8 167.2 288 176 288H208C216.8 288 224 280.8 224 272V240C224 231.2 216.8 224 208 224H176zM256 272C256 280.8 263.2 288 272 288H304C312.8 288 320 280.8 320 272V240C320 231.2 312.8 224 304 224H272C263.2 224 256 231.2 256 240V272zM80 96C71.16 96 64 103.2 64 112V144C64 152.8 71.16 160 80 160H112C120.8 160 128 152.8 128 144V112C128 103.2 120.8 96 112 96H80zM160 144C160 152.8 167.2 160 176 160H208C216.8 160 224 152.8 224 144V112C224 103.2 216.8 96 208 96H176C167.2 96 160 103.2 160 112V144zM272 96C263.2 96 256 103.2 256 112V144C256 152.8 263.2 160 272 160H304C312.8 160 320 152.8 320 144V112C320 103.2 312.8 96 304 96H272z" fill="#5014d0"/>
			</svg> {nodes.name}</>} classes={{ content : "py-2" }} >
			{Array.isArray(nodes.children)
				? nodes.children.map((node) => renderTree(node))
				: null}
		</TreeItem>
	);

	return <>
		{partnertree.length > 0 && selected && <TreeView
			aria-label="rich object"
			defaultCollapseIcon={<ExpandMoreIcon />}
			defaultExpanded={allpartner.map(x => x._id)}
			defaultSelected={selected}
			selected={selected}
			onNodeSelect={onChanged}
			defaultExpandIcon={<ChevronRightIcon />}
			sx={{ 
				height: 400, 
				flexGrow: 1, 
				overflowY: 'auto' 
			}} >
			{renderTree(partnertree[0])}
		</TreeView>}
	</>
}

const mapState = (state) => {
	const user =  state.AuthReducer.user;
	const allgroups =  state.ProgramReducer.allgroups;
	const allpartner =  state.ProgramReducer.allpartner;
	const partnertree =  state.ProgramReducer.partnertree;
	const mypartner =  state.ProgramReducer.mypartner;

	return { user, allgroups, mypartner, partnertree, allpartner };
};

const mapDispatch = (dispatch) => ({
	
});

export default connect(mapState, mapDispatch)(PartnerTree);
